module.exports = __webpack_public_path__ + "img/speelmuur.91361079.jpg";